require('moment-timezone')
/**
 *
 * @param date
 * @param inputFormat
 * @param inputTimeZone
 * @param asDate
 * @returns {*}
 */
function dateFormatter(date, inputFormat = 'YYYY-MM-DD HH:mm:ss', inputTimeZone = 'UTC', asDate = false) {
    let outputDate = moment.tz(date, inputFormat, inputTimeZone);
    if (asDate) {
        return outputDate.clone().tz('America/Panama');
    } else {
        return outputDate.clone().tz('America/Panama').format(inputFormat);
    }
}

const CURRENCY_FORMATTER = new Intl.NumberFormat('es-PA', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});


const HumanReadable = {
    BASE: 1,
    KILO: 1000,
    MEGA: 1000 * 1000,
    GIGA: 1000 * 1000 * 1000,
    TERA: 1000 * 1000 * 1000 * 1000,

    formatData: function (value, unit) {
        let baseValue = value * unit;

        if (baseValue >= HumanReadable.TERA) {
            return `${baseValue / HumanReadable.TERA} Tb`
        } else if (baseValue >= HumanReadable.GIGA) {
            return `${baseValue / HumanReadable.GIGA} Gb`
        } else if (baseValue >= HumanReadable.MEGA) {
            return `${baseValue / HumanReadable.MEGA} Mb`
        } else if (baseValue >= HumanReadable.KILO) {
            return `${baseValue / HumanReadable.KILO} Kb`
        } else {
            return `${baseValue} B`

        }
    }
}

function buildUrl(path) {
    if (path && path.startsWith('/')) {
        path = path.replace('/', '');
    }

    return `${window.location.origin}/${path}`;
}

/**
 *
 * @param {object} data
 * @param {string|null} parentKey
 * @param {FormData|null} formData
 * @returns {FormData}
 */
function buildFormData(data, parentKey = null, formData = null) {
    if (!formData) {
        formData = new FormData();
    }

    if (typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && !(data instanceof Blob)) {
        let keys = Object.keys(data);
        console.log('keys', keys);
        for (let k of keys) {
            let value = data[k];
            let key = parentKey ? `${parentKey}[${k}]`: k;
            formData = buildFormData(value, key, formData);
        }

    } else  if (data instanceof File) {
        console.log('file', parentKey, data)
        formData.append(parentKey, data)
    } else if (data instanceof Blob) {
        console.log('blob', parentKey, data)
        formData.append(parentKey, data, parentKey);
    } else {
        console.log('primitive', parentKey, data)
        formData.append(parentKey, data);
    }

    return formData;
}

async function dataUrlToFile(dataUrl, filename = 'image.png') {
  const res = await fetch(dataUrl);
  const blob = await res.blob();
  return new File([blob], filename, { type: blob.type, lastModified: Date.now() });
}

function roundTo(v, base = 10) {
    return Math.pow(base, Math.ceil(Math.log10(v)));
}

function jsonToFormData(data) {
    const formData = new FormData();

    buildFormData(formData, data);

    return formData;
}


export {
    dateFormatter,
    CURRENCY_FORMATTER,
    HumanReadable,
    buildUrl,
    buildFormData,
    roundTo,
    dataUrlToFile
};
